import { render, staticRenderFns } from "./Expense.vue?vue&type=template&id=436e7ed6&scoped=true"
import script from "./Expense.vue?vue&type=script&lang=js"
export * from "./Expense.vue?vue&type=script&lang=js"
import style0 from "./Expense.vue?vue&type=style&index=0&id=436e7ed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e7ed6",
  null
  
)

export default component.exports